import { Component, ElementRef, inject, input, OnInit } from "@angular/core";
import { VdsDialogRef } from "../dialog-ref";
import { VdsDialog } from "../dialog";
import { getClosestDialog } from "../dialog-utils";
import { VdsIconButtonComponent } from "@cce/design-system/button";
import { VdsIconComponent } from "@cce/design-system/icon";
import { VdsDialogCloseDirective } from "../dialog-close.directive";

@Component({
    selector: "vds-dialog-header",
    templateUrl: "./dialog-header.component.html",
    host: { class: "vds-dialog-header" },
    imports: [VdsIconButtonComponent, VdsIconComponent, VdsDialogCloseDirective]
})
export class VdsDialogHeaderComponent implements OnInit {
    private dialogRef = inject<VdsDialogRef<any>>(VdsDialogRef, { optional: true });
    private elementRef = inject<ElementRef<HTMLElement>>(ElementRef);
    private dialog = inject(VdsDialog);

    protected readonly disableClose = this.dialogRef?.disableClose;

    readonly title = input<string>();

    readonly closeLabel = input<string>("Close");

    readonly dialogResult = input<any>();

    ngOnInit(): void {
        if (!this.dialogRef) {
            this.dialogRef = getClosestDialog(this.elementRef, this.dialog.openDialogs)!;
        }
    }
}
